

// export const mockDataProductsResponse = {
//   page: 1,
//   pageSize: 6,
//   totalCount: 6,
//   totalPages: 1,
//   dataContracts: [
//     {
//       id: "P001",
//       name: "Customer Segmentation ML Model",
//       description: "Model that clusters customers using behavioral segmentation.",
//       status: "critical",
//       consumerDependencies: []
//     },
//     {
//       id: "P002",
//       name: "Executive Analytics Dashboard",
//       description: "Dashboard showing business KPIs for leadership decision-making.",
//       status: "warning",
//       consumerDependencies: []
//     },
//     {
//       id: "P003",
//       name: "Customer Purchase Trend Analyzer",
//       description: "Analyzes customer purchase frequency and product preferences.",
//       status: "healthy",
//       consumerDependencies: []
//     },
//     {
//       id: "P004",
//       name: "Customer Service Portal",
//       description: "Portal for customers to manage service requests and track resolutions.",
//       status: "critical",
//       consumerDependencies: []
//     },
//     {
//       id: "P005",
//       name: "Support Performance Dashboard",
//       description: "Dashboard to measure customer support performance and SLA compliance.",
//       status: "healthy",
//       consumerDependencies: []
//     },
//     {
//       id: "P006",
//       name: "Customer Feedback Topic Model",
//       description: "NLP model that extracts insights from customer survey comments.",
//       status: "warning",
//       consumerDependencies: []
//     }
//   ],

//   filters: {
//     parent_domains: [
//       {
//         parent_domain_id: "PD1",
//         parent_domain: "Data Intelligence",
//         domains: [
//           {
//             domain_id: "D11",
//             domain: "Insight Modeling",
//             sub_domains: [
//               {
//                 sub_domain_id: "SD111",
//                 sub_domain: "Customer Clustering",
//                 products: [
//                   "Customer Segmentation ML Model",
//                   "Executive Analytics Dashboard"
//                 ]
//               }
//             ]
//           },
//           {
//             domain_id: "D12",
//             domain: "Behavior Metrics",
//             sub_domains: [
//               {
//                 sub_domain_id: "SD121",
//                 sub_domain: "Purchase Behavior Signals",
//                 products: [
//                   "Customer Purchase Trend Analyzer"
//                 ]
//               }
//             ]
//           }
//         ]
//       },

//       {
//         parent_domain_id: "PD2",
//         parent_domain: "Customer Operations",
//         domains: [
//           {
//             domain_id: "D21",
//             domain: "Service Management",
//             sub_domains: [
//               {
//                 sub_domain_id: "SD211",
//                 sub_domain: "Customer Support Systems",
//                 products: [
//                   "Customer Service Portal",
//                   "Support Performance Dashboard"
//                 ]
//               }
//             ]
//           },
//           {
//             domain_id: "D22",
//             domain: "Experience Analytics",
//             sub_domains: [
//               {
//                 sub_domain_id: "SD221",
//                 sub_domain: "Sentiment Interpretation",
//                 products: [
//                   "Customer Feedback Topic Model"
//                 ]
//               }
//             ]
//           }
//         ]
//       }
//     ]
//   }
// };
export const mockDataProductsResponse = {
  page: 1,
  pageSize: 6,
  totalCount: 6,
  totalPages: 1,
  dataContracts: [
    {
      id: "P001",
      name: "Customer Analytics",
      description: "Core customer behavior and transaction data pipeline feeding ML models and business intelligence.",
      status: "healthy",
      consumerDependencies: [
        {
          id: 'c1',
          name: 'Customer Segmentation ML Model',
          type: 'ml_model',
          status: 'active',
          lastAccessed: '1 min ago',
          dependencies: [
            {
              id: 'c1-1',
              name: 'Marketing Campaign Dashboard',
              type: 'dashboard',
              status: 'active',
              lastAccessed: '5 min ago'
            },
            {
              id: 'c1-2',
              name: 'Personalization API',
              type: 'api',
              status: 'active',
              lastAccessed: '2 min ago'
            }
          ]
        },
        {
          id: 'c2',
          name: 'Executive Analytics Dashboard',
          type: 'dashboard',
          status: 'active',
          lastAccessed: '3 min ago',
          dependencies: [
            {
              id: 'c2-1',
              name: 'Monthly Business Report',
              type: 'report',
              status: 'active',
              lastAccessed: '1 hour ago'
            }
          ]
        },
        {
          id: 'c3',
          name: 'Customer Service Portal',
          type: 'service',
          status: 'active',
          lastAccessed: '30 sec ago'
        }
      ]    },
    {
      id: "P002",
      name: "Inventory Management",
      description: "Real-time inventory levels and warehouse operations data for supply chain optimization.",
      status: "warning",
      consumerDependencies: [
        {
          id: 'i1',
          name: 'Supply Chain Dashboard',
          type: 'dashboard',
          status: 'active',
          lastAccessed: '5 min ago'
        },
        {
          id: 'i2',
          name: 'Warehouse Management System',
          type: 'service',
          status: 'error',
          lastAccessed: '2 hours ago',
          dependencies: [
            {
              id: 'i2-1',
              name: 'Inventory Alert Service',
              type: 'service',
              status: 'inactive',
              lastAccessed: '3 hours ago'
            }
          ]
        },
        {
          id: 'i3',
          name: 'Procurement API',
          type: 'api',
          status: 'active',
          lastAccessed: '10 min ago'
        }
      ]    },
    {
      id: "P003",
      name: "Financial Reporting",
      description: "Critical financial data pipeline for regulatory compliance and executive reporting.",
      status: "critical",
      consumerDependencies: [
        {
          id: 'f1',
          name: 'Regulatory Compliance System',
          type: 'service',
          status: 'error',
          lastAccessed: '1 hour ago',
          dependencies: [
            {
              id: 'f1-1',
              name: 'SEC Filing Generator',
              type: 'service',
              status: 'error',
              lastAccessed: '2 hours ago'
            },
            {
              id: 'f1-2',
              name: 'Audit Trail Service',
              type: 'service',
              status: 'inactive',
              lastAccessed: '3 hours ago'
            }
          ]
        },
        {
          id: 'f2',
          name: 'CFO Dashboard',
          type: 'dashboard',
          status: 'inactive',
          lastAccessed: '2 hours ago'
        },
        {
          id: 'f3',
          name: 'Financial Planning Model',
          type: 'ml_model',
          status: 'error',
          lastAccessed: '1.5 hours ago'
        }
      ]    },
    {
      id: "P004",
      name: "User Activity Stream",
      description: "High-volume user interaction and engagement metrics for product analytics.",
      status: "healthy",
      consumerDependencies: [
        {
          id: 'u1',
          name: 'Product Analytics Dashboard',
          type: 'dashboard',
          status: 'active',
          lastAccessed: '30 sec ago'
        },
        {
          id: 'u2',
          name: 'User Behavior ML Pipeline',
          type: 'ml_model',
          status: 'active',
          lastAccessed: '1 min ago',
          dependencies: [
            {
              id: 'u2-1',
              name: 'Recommendation Engine',
              type: 'service',
              status: 'active',
              lastAccessed: '45 sec ago'
            },
            {
              id: 'u2-2',
              name: 'A/B Testing Platform',
              type: 'service',
              status: 'active',
              lastAccessed: '2 min ago'
            }
          ]
        }
      ]    },
    {
      id: "P005",
      name: "Marketing Attribution",
      description: "Campaign performance and customer acquisition cost analysis data pipeline.",
      status: "warning",
      consumerDependencies: [
        {
          id: 'm1',
          name: 'Campaign Performance Dashboard',
          type: 'dashboard',
          status: 'active',
          lastAccessed: '5 min ago'
        },
        {
          id: 'm2',
          name: 'Attribution Model',
          type: 'ml_model',
          status: 'active',
          lastAccessed: '8 min ago'
        }
      ]    },
    {
      id: "P006",
      name: "Product Catalog",
      description: "Master product data including pricing, availability, and specifications across all channels.",
      status: "healthy",
      consumerDependencies: []
    }
  ],
  filters: {
    parent_domains: [
      {
        parent_domain_id: "PD1",
        parent_domain: "Customer Intelligence",
        domains: [
          {
            domain_id: "D11",
            domain: "Customer Data Pipelines",
            sub_domains: [
              {
                sub_domain_id: "SD111",
                sub_domain: "Behavioral Segmentation",
                products: ["Customer Analytics"]
              }
            ]
          }
        ]
      },
      {
        parent_domain_id: "PD2",
        parent_domain: "Supply Chain Operations",
        domains: [
          {
            domain_id: "D21",
            domain: "Inventory Systems",
            sub_domains: [
              {
                sub_domain_id: "SD211",
                sub_domain: "Warehouse Optimization",
                products: ["Inventory Management"]
              }
            ]
          }
        ]
      },
      {
        parent_domain_id: "PD3",
        parent_domain: "Finance & Compliance",
        domains: [
          {
            domain_id: "D31",
            domain: "Regulatory Data",
            sub_domains: [
              {
                sub_domain_id: "SD311",
                sub_domain: "Audit & Governance",
                products: ["Financial Reporting"]
              }
            ]
          }
        ]
      },
      {
        parent_domain_id: "PD4",
        parent_domain: "Product Analytics",
        domains: [
          {
            domain_id: "D41",
            domain: "Usage Insights",
            sub_domains: [
              {
                sub_domain_id: "SD411",
                sub_domain: "Engagement Metrics",
                products: ["User Activity Stream"]
              }
            ]
          }
        ]
      },
      {
        parent_domain_id: "PD5",
        parent_domain: "Marketing Performance",
        domains: [
          {
            domain_id: "D51",
            domain: "Campaign Analytics",
            sub_domains: [
              {
                sub_domain_id: "SD511",
                sub_domain: "Attribution Models",
                products: ["Marketing Attribution"]
              }
            ]
          }
        ]
      },
      {
        parent_domain_id: "PD6",
        parent_domain: "Commerce & Product Data",
        domains: [
          {
            domain_id: "D61",
            domain: "Product Master Data",
            sub_domains: [
              {
                sub_domain_id: "SD611",
                sub_domain: "Catalog Synchronization",
                products: ["Product Catalog"]
              }
            ]
          }
        ]
      }
    ]
  }
};


// export const mockSubscriptionsResponse = {
//   page: 1,
//   pageSize: 3,
//   totalCount: 3,
//   totalPages: 1,
//   dataContracts: [
//     {
//       id: "P001",
//       name: "Customer Segmentation ML Model",
//       description: "Machine learning model used to cluster customers based on behavioral attributes and transaction history.",
//       status: "critical",
//       lastUpdated: "3 min ago",
//       dataSource: "PostgreSQL",
//       consumers: 14,
//       slaCompliance: 91,
//       dataQuality: 94,
//       freshness: "< 10 min",
//       consumerDependencies: [
//         {
//           id: "cs1",
//           name: "Marketing Campaign Dashboard",
//           type: "dashboard",
//           status: "active",
//           lastAccessed: "6 min ago"
//         },
//         {
//           id: "cs2",
//           name: "Personalization Engine API",
//           type: "api",
//           status: "active",
//           lastAccessed: "2 min ago"
//         }
//       ]
//     },
//     {
//       id: "P004",
//       name: "Customer Churn Prediction Model",
//       description: "Predictive intelligence model estimating the probability of a customer stopping their engagement.",
//       status: "warning",
//       lastUpdated: "12 min ago",
//       dataSource: "Snowflake",
//       consumers: 9,
//       slaCompliance: 84,
//       dataQuality: 89,
//       freshness: "28 min",
//       consumerDependencies: [
//         {
//           id: "cp1",
//           name: "Customer Success Dashboard",
//           type: "dashboard",
//           status: "active",
//           lastAccessed: "9 min ago"
//         },
//         {
//           id: "cp2",
//           name: "Retention Campaign Service",
//           type: "service",
//           status: "active",
//           lastAccessed: "15 min ago",
//           dependencies: [
//             {
//               id: "cp2-1",
//               name: "Email Outreach API",
//               type: "api",
//               status: "active",
//               lastAccessed: "7 min ago"
//             }
//           ]
//         }
//       ]
//     },
//     {
//       id: "P006",
//       name: "Support Performance Dashboard",
//       description: "Operational analytics dashboard visualizing ticket handling performance and service SLAs for support teams.",
//       status: "healthy",
//       lastUpdated: "1 min ago",
//       dataSource: "BigQuery",
//       consumers: 22,
//       slaCompliance: 98,
//       dataQuality: 97,
//       freshness: "< 2 min",
//       consumerDependencies: [
//         {
//           id: "sd1",
//           name: "Service Response Time Alerts",
//           type: "service",
//           status: "active",
//           lastAccessed: "50 sec ago"
//         },
//         {
//           id: "sd2",
//           name: "Support Ticket NLP Classifier",
//           type: "ml_model",
//           status: "active",
//           lastAccessed: "3 min ago"
//         }
//       ]
//     }
//   ],
//   filters: {
//     parent_domains: [
//       {
//         parent_domain_id: "PD1",
//         parent_domain: "Customer Analytics",
//         domains: [
//           {
//             domain_id: "D12",
//             domain: "Behavior Analysis",
//             sub_domains: [
//               {
//                 sub_domain_id: "SD122",
//                 sub_domain: "Churn Factors",
//                 products: ["Customer Churn Prediction Model"]
//               },
//               {
//                 sub_domain_id: "SD121",
//                 sub_domain: "Purchase Trends",
//                 products: ["Customer Segmentation ML Model"]
//               }
//             ]
//           }
//         ]
//       },
//       {
//         parent_domain_id: "PD2",
//         parent_domain: "Customer Engagement",
//         domains: [
//           {
//             domain_id: "D21",
//             domain: "Support Services",
//             sub_domains: [
//               {
//                 sub_domain_id: "SD212",
//                 sub_domain: "Service Quality",
//                 products: ["Support Performance Dashboard"]
//               }
//             ]
//           }
//         ]
//       }
//     ]
//   }
// };
export const mockSubscriptionsResponse = {
  page: 1,
  pageSize: 3,
  totalCount: 3,
  totalPages: 1,
  dataContracts: [
    {
      id: "P001",
      name: "Customer Segmentation ML Model",
      description: "Machine learning model used to cluster customers based on behavioral attributes and transaction history.",
      status: "critical",
      lastUpdated: "3 min ago",
      dataSource: "PostgreSQL",
      consumers: 14,
      slaCompliance: 91,
      dataQuality: 94,
      freshness: "< 10 min",
      consumerDependencies: [
        {
          id: "cs1",
          name: "Marketing Campaign Dashboard",
          type: "dashboard",
          status: "active",
          lastAccessed: "6 min ago"
        },
        {
          id: "cs2",
          name: "Personalization Engine API",
          type: "api",
          status: "active",
          lastAccessed: "2 min ago"
        }
      ]
    },
    {
      id: "P004",
      name: "Customer Churn Prediction Model",
      description: "Predictive intelligence model estimating the probability of a customer stopping their engagement.",
      status: "warning",
      lastUpdated: "12 min ago",
      dataSource: "Snowflake",
      consumers: 9,
      slaCompliance: 84,
      dataQuality: 89,
      freshness: "28 min",
      consumerDependencies: [
        {
          id: "cp1",
          name: "Customer Success Dashboard",
          type: "dashboard",
          status: "active",
          lastAccessed: "9 min ago"
        },
        {
          id: "cp2",
          name: "Retention Campaign Service",
          type: "service",
          status: "active",
          lastAccessed: "15 min ago",
          dependencies: [
            {
              id: "cp2-1",
              name: "Email Outreach API",
              type: "api",
              status: "active",
              lastAccessed: "7 min ago"
            }
          ]
        }
      ]
    },
    {
      id: "P006",
      name: "Support Performance Dashboard",
      description: "Operational analytics dashboard visualizing ticket handling performance and service SLAs for support teams.",
      status: "healthy",
      lastUpdated: "1 min ago",
      dataSource: "BigQuery",
      consumers: 22,
      slaCompliance: 98,
      dataQuality: 97,
      freshness: "< 2 min",
      consumerDependencies: [
        {
          id: "sd1",
          name: "Service Response Time Alerts",
          type: "service",
          status: "active",
          lastAccessed: "50 sec ago"
        },
        {
          id: "sd2",
          name: "Support Ticket NLP Classifier",
          type: "ml_model",
          status: "active",
          lastAccessed: "3 min ago"
        }
      ]
    }
  ],

  filters: {
    parent_domains: [
      {
        parent_domain_id: "PD1",
        parent_domain: "Customer Intelligence",
        domains: [
          {
            domain_id: "D11",
            domain: "Insight Modeling",
            sub_domains: [
              {
                sub_domain_id: "SD111",
                sub_domain: "Customer Clustering",
                products: ["Customer Segmentation ML Model"]
              }
            ]
          },
          {
            domain_id: "D12",
            domain: "Behavior Metrics",
            sub_domains: [
              {
                sub_domain_id: "SD121",
                sub_domain: "Churn Analysis",
                products: ["Customer Churn Prediction Model"]
              }
            ]
          }
        ]
      },

      {
        parent_domain_id: "PD2",
        parent_domain: "Customer Operations",
        domains: [
          {
            domain_id: "D21",
            domain: "Service Management",
            sub_domains: [
              {
                sub_domain_id: "SD211",
                sub_domain: "Support Quality",
                products: ["Support Performance Dashboard"]
              }
            ]
          }
        ]
      }
    ]
  }
};
